define('v3/Common/Components/SubjectGroupsDropdown/SubjectGroupsDropdown.Component',[
	'knockout',
	'lodash',
	'v3/Common/Components/SubjectGroupsDropdown/Services/subjectGroupService',
	'v3/Common/Services/pageStateService',
	'v3/Common/Services/frontend/Frontend.Service',
	'text!v3/Common/Components/SubjectGroupsDropdown/SubjectGroupsDropdown.Component.html',
	'safe-mode',
	'v3/Common/Bindings/Select.Binding'
], function (ko, _, subjectGroupService, pageStateService, frontend, htmlString, safeModeService) {
	var pageStateSubjectGroupId = pageStateService.getNumberObservable('subjectGroupId');
	if (pageStateSubjectGroupId()) {
		subjectGroupService.saveSubjectGroupId(pageStateSubjectGroupId());
	}

	function validateParams (params) {
		if (!ko.isWriteableObservable(params.selectedSubjectGroupId)) {
			throw new Error('Please provide params.selectedSubjectGroupId as a writable observable.');
		}

		params.filter || (params.filter = 'all');
		params.loadState = params.loadState !== false;
	}

	function SubjectGroupsDropdownViewModel (params) {
		var self = this;
		validateParams(params);

		self.subjectGroups = ko.observableArray();

		self.selectedSubjectGroupId = params.selectedSubjectGroupId;
		var selectedSubjectGroupSubscriber = self.selectedSubjectGroupId.subscribe(function (subjectGroupId) {
			if (!subjectGroupId) return;

			trySelectSubjectGroupNameInParams(subjectGroupId);

			subjectGroupService.saveSubjectGroupId(subjectGroupId);
			pageStateSubjectGroupId(subjectGroupId);
			subjectGroupService.getSubjectGroupGradeDetails(subjectGroupId)
				.then(function (data) {
					safeModeService.safeMode.setSubjectId(data.subjectId);
					safeModeService.safeMode.setGrade(data.grade);
					safeModeService.safeMode.setCourseId(null);
					safeModeService.safeMode.setSectionId(null);
					safeModeService.safeMode.setLessonId(null);
				});
		});

		self.enabledSubjectGroupIds = ko.observableArray();
		if (params.pupilIdForSubjectGroupDisabling) {
			var pupilIdForSubjectGroupDisablingSubscription = params.pupilIdForSubjectGroupDisabling.subscribe(function () {
				fetchSubjectGroupsWithDisabling();
			});
		}

		self.disabled = params.disabled || false;

		function getFetchSubjectGroupsDeferred (filter) {
			switch (filter) {
			case 'all':
				return subjectGroupService.getAllSubjectGroups();
			case 'educationPlanExistsForClass':
				return subjectGroupService.getSubjectGroupsWhereEducationPlanExists();
			case 'buildEducationPlanFromScratch':
				return subjectGroupService.getAllSubjectGroups();
			default:
				throw new Error('Not supported params.filter parameter: ' + params.filter);
			}
		}
		var fetchSubjectGroupsDeferred = getFetchSubjectGroupsDeferred(params.filter);

		function selectFirstEnabledOrNull () {
			var firstActiveSg = _.find(self.subjectGroups(), { disable: false });
			var newSelectedSgId = firstActiveSg ? firstActiveSg.id : null;
			self.selectedSubjectGroupId(newSelectedSgId);
			if (params.pupilIdForSubjectGroupDisabling) {
				frontend.notification.info({
					text: Strings.SubjectSelectionChanged,
					hide: true,
					delay: 5000
				});
			}
		}

		function trySelectSubjectGroupNameInParams (subjectGroupId) {
			if (ko.isWritableObservable(params.selectedSubjectGroupItem)) {
				var subjectGroup = _.find(self.subjectGroups(), { id: subjectGroupId });
				params.selectedSubjectGroupItem(subjectGroup);
			}
		}

		function fetchSubjectGroupsWithDisabling () {
			var pupilId = ko.unwrap(params.pupilIdForSubjectGroupDisabling);
			var isEnabledSubjectGroupCheckRequired = (pupilId !== undefined);
			if (isEnabledSubjectGroupCheckRequired) {
				subjectGroupService
					.getPupilSubjectGroupIdsWhereEducationPlanExists(pupilId)
					.done(function (pupilSubjectGroupIds) {
						self.enabledSubjectGroupIds(pupilSubjectGroupIds);
						fetchSubjectGroups(isEnabledSubjectGroupCheckRequired);
					});
			} else {
				fetchSubjectGroups(isEnabledSubjectGroupCheckRequired);
			}
		}

		function fetchSubjectGroups (isEnabledSubjectGroupCheckRequired) {
			fetchSubjectGroupsDeferred
				.done(function (subjectGroupList) {
					var subjectGroups = _.cloneDeep(subjectGroupList);
					if (params.noSelectionCaption) {
						var noSelectionCaptionExists = _.some(subjectGroups, ['id', null]);
						if (!noSelectionCaptionExists) {
							subjectGroups.unshift({ id: null, name: params.noSelectionCaption });
						}
					}

					if (subjectGroups.length === 0 && params.noSubjectGroupsCaption) {
						subjectGroups.unshift({ id: null, name: params.noSubjectGroupsCaption });
					}

					_.forEach(subjectGroups, function (sg) {
						sg.disable = isEnabledSubjectGroupCheckRequired &&
							!_.includes(self.enabledSubjectGroupIds(), sg.id);
					});

					// invalidation of the disable drop down binding with the same set of objects
					self.subjectGroups([]);
					self.subjectGroups(subjectGroups);

					var initialSubjectGroupId = self.selectedSubjectGroupId() || pageStateSubjectGroupId() || subjectGroupService.getSubjectGroupId();
					if (initialSubjectGroupId && params.loadState && _.some(subjectGroups, { id: initialSubjectGroupId, disable: false })) {
						self.selectedSubjectGroupId(initialSubjectGroupId);
					} else {
						selectFirstEnabledOrNull();
					}

					if (self.selectedSubjectGroupId() !== null) {
						pageStateSubjectGroupId(self.selectedSubjectGroupId());
						trySelectSubjectGroupNameInParams(self.selectedSubjectGroupId());
					}
				});
		}

		fetchSubjectGroupsWithDisabling();

		self.dispose = function () {
			selectedSubjectGroupSubscriber.dispose();
			if (pupilIdForSubjectGroupDisablingSubscription) pupilIdForSubjectGroupDisablingSubscription.dispose();
		};
	}

	return { viewModel: SubjectGroupsDropdownViewModel, template: htmlString };
});
